import React from 'react'
import { Logo } from '../../../assets'
import { CustomBox } from './stylesHT'
import { AppBar, Toolbar, Box, Typography } from '@mui/material'
import { AuthContext } from '../../../contexts/AuthContext'
import RouterHook from '../../../contexts/RouterHook'
import { UsuarioContext } from '../../../contexts/UsuarioContext'
import { Services } from '../../../services'

export default function ContainH({ children }) {
  const serverRouter = RouterHook()
  const { sttAuthCtx } = React.useContext(AuthContext)
  const { userUCtx } = React.useContext(UsuarioContext)

  return (
    <CustomBox>
      <AppBar className='contain-header-top-limited' position='static'>
        <Toolbar
          className='contain-header-img-title'
          title='Agendei Quadras'
          onClick={() => {
            if (sttAuthCtx.isLogged && userUCtx.usuario) {
              serverRouter('home', Services.ReturnLabelURL(userUCtx.usuario.estado, userUCtx.usuario.cidade))
            } else {
              serverRouter('login')
            }
          }}
        >
          <Box component='img' src={Logo} alt='Agendei Quadras' />
          <Typography component='h2' className='title-aplication'>
            Agendei Quadras
          </Typography>
        </Toolbar>
        <Box className='contain-header-children'>{children}</Box>
      </AppBar>
    </CustomBox>
  )
}
